import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import fetch from 'isomorphic-fetch';
import { checkHttpStatus, parseJSON } from '../../utils';
import { setCurrentSection } from '../../actions/globalConfig';
import './styles.scss';

const propTypes = {
  statusText: PropTypes.string,
  sectionName: PropTypes.string,
  userName: PropTypes.string,
  profileImage: PropTypes.string
};

const defaultProps = {
  sectionName: 'faqs',
  statusText: '',
  userName: '',
  profileImage: 'https://explore.org/images/icon_avatar_default.png'
};

class FaqsView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      faqsData: [],
    };
  }

  fetchFaqs() {
    return fetch(`${SERVER_URL}/get_faqs`)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        this.setState({ 'faqsData': response.data }, () => {
          if (window.location.hash) {
            const hashValue = window.location.hash;
            // the next line is required to work around a bug in WebKit (Chrome / Safari)
            location.href = `${hashValue}`;
          }
        });
      })
      .catch((error) => {
        console.log(error, 'An error occurred');
        return Promise.resolve(); // TODO: we need a promise here because of the tests, find a better way
      });
  }

  componentWillMount() {
    this.fetchFaqs();
    this.props.dispatch(setCurrentSection(this.props.sectionName));
  }

  generateHtml (html) {
    return {__html: html};
  }

  render() {
    const { faqsData: faqs } = this.state;
    if (!faqs) {
      return null;
    }

    return (
      <div className="container-fluid content faqs-page bg-fff-65">
        <div className="row">
          <div className="col-sm-12 pr-35 pl-35">
            <h1>Frequently Asked Questions</h1>
            <div className="text-justify">
              <div className="container-fluid text-left">
                <div className="row">
                  <div className="col-auto faq-toc">
                    <h4>Table of Contents</h4>
                    <ul>
                      {faqs.map((faq) => {
                        return (
                          <li key={faq.id}>
                            <a href={`#faq-${faq.id}`}>{faq.question}</a>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
                {faqs.map((faq) => {
                  return (
                    <div key={faq.id}>
                      <div className="position-relative">
                        <div id={`faq-${faq.id}`} className="faq-link">&nbsp;</div>
                      </div>
                      <div className="align-items-center faq-question results-wrapper row">
                        <div className="col-auto faq-letter">Q.</div>
                        <div className="col">{faq.question}</div>
                      </div>
                      <div className="faq-answer row">
                        <div className="col-auto faq-letter">A.</div>
                        <div className="col pt-2" dangerouslySetInnerHTML={this.generateHtml(faq.answer)} />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>);
  }
}


const mapStateToProps = (state) => {
  return {
    userName: state.auth.userName,
    statusText: state.auth.statusText,
    previousPath: state.globalConfig.previousPath
  };
};

FaqsView.propTypes = propTypes;
FaqsView.defaultProps = defaultProps;

export default connect(mapStateToProps)(FaqsView);
